import { lazy } from "react"

export const ManagerAccountMainPage = lazy(() => import("./ManagerAccountMainPage"))
